import PiwikProProvider from '@piwikpro/next-piwik-pro'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useRouter } from 'next/router'

import '../i18n/i18n'

import CookiebotDeclarationProvider from '@contexts/CookiebotDeclaration'
import LoaderProvider from '@contexts/DataLoader'
import ModalProvider from '@contexts/Modal'
import PageContextProvider from '@contexts/PageContext'
import ResponsiveProvider from '@contexts/Responsive'
import SubmenuBackgroundProvider from '@contexts/SubmenuBackground'
import ThemeProvider from '@contexts/Theme'

function ArcaApp({ Component, pageProps, nonce }) {
  const router = useRouter()
  const getPageType = () => {
    const path = router.asPath

    if (path.includes('/di-che-ramo-sei/educational-danni')) {
      const isParent =
        path === '/di-che-ramo-sei/educational-danni' ||
        path === '/di-che-ramo-sei/educational-danni/'
      return { pageType: 'educational-danni', isParent }
    } else if (path.includes('/di-che-ramo-sei/educational-vita')) {
      const isParent =
        path === '/di-che-ramo-sei/educational-vita' ||
        path === '/di-che-ramo-sei/educational-vita/'
      return { pageType: 'educational-vita', isParent }
    }

    return { pageType: undefined, isParent: undefined }
  }

  const pageType = getPageType()

  return (
    <PageContextProvider
      pageType={pageType?.pageType}
      isParent={pageType?.isParent}
    >
      <ThemeProvider>
        <ResponsiveProvider>
          <LoaderProvider>
            <ModalProvider>
              <SubmenuBackgroundProvider>
                <GoogleReCaptchaProvider
                  reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_API_KEY}
                  language='it'
                  scriptProps={{
                    nonce: `nonce-${nonce}`,
                  }}
                >
                  <PiwikProProvider
                    containerId={process.env.NEXT_PUBLIC_PIWIK_PRO_CONTAINER_ID}
                    containerUrl={process.env.NEXT_PUBLIC_PIWIK_PRO_CONTAINER_URL}
                    nonce={`nonce-${nonce}`}
                  >
                    <CookiebotDeclarationProvider nonce={nonce}>
                      <Component
                        {...pageProps}
                        nonce={nonce}
                      />
                    </CookiebotDeclarationProvider>
                  </PiwikProProvider>
                </GoogleReCaptchaProvider>
              </SubmenuBackgroundProvider>
            </ModalProvider>
          </LoaderProvider>
        </ResponsiveProvider>
      </ThemeProvider>
    </PageContextProvider>
  )
}

export default ArcaApp
